// File generated from our OpenAPI spec by Stainless.
export class APIResource {
    constructor(client) {
        this._client = client;
    }
}
//# sourceMappingURL=resource.mjs.map